module.exports = __webpack_public_path__ + "img/hiring_banner.7d2c628e.jpg";